"use client";

import { useEffect, useState } from "react";

export function ScrollProgressBar() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const { scrollY, innerHeight } = window;
      const total = document.documentElement.scrollHeight - innerHeight;
      setProgress(total > 0 ? scrollY / total : 0);
    };

    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <div aria-hidden="true" className="relative h-32 w-px">
      <div className="absolute inset-0 bg-border" />
      <div
        className="absolute inset-x-0 top-0 h-full origin-top bg-foreground/50"
        style={{ transform: `scaleY(${progress})` }}
      />
    </div>
  );
}
